const TOKEN_KEY = "auth_token";
const LOGIN_MODE_KEY = "auth_login_mode";

export type LoginMode = "password" | "email";

/**
 * Which sign-in method this browser used last. Accounts created from an email
 * invite have no password at all, so opening on the password form every time
 * costs them a click before they can even start.
 */
export function getLoginMode(): LoginMode {
  try {
    return localStorage.getItem(LOGIN_MODE_KEY) === "email" ? "email" : "password";
  } catch {
    return "password";
  }
}

export function rememberLoginMode(mode: LoginMode) {
  try {
    localStorage.setItem(LOGIN_MODE_KEY, mode);
  } catch {
    // A browser with site data blocked simply won't remember the choice.
  }
}

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isLoggedIn(): boolean {
  return !!getToken();
}
